import React, { ReactNode } from 'react'
import { Modal } from 'react-bootstrap'
import './BaseModal.css'

interface BaseModalProps {
  className?: string
  show: boolean
  handleClose: () => void
  title: string
  children: ReactNode
  footer?: ReactNode
  size?: 'lg' | 'sm' | 'xl' | undefined
}

const BaseModal: React.FC<BaseModalProps> = ({
  className = '',
  show,
  handleClose,
  title,
  children,
  footer,
  size,
}) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size={size}
      className={`${className}`}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {footer && <Modal.Footer>{footer}</Modal.Footer>}
    </Modal>
  )
}

export default BaseModal
